import React from "react";
import styled from "styled-components";
import Button from "components/atoms/Button/Button";
import Modal from "utils/Modal/Modal";
import ModalBase from "./ModalBase";

const StyledModalBase = styled(ModalBase)`
  width: 550px;
`;

const ButtonsWrapper = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 20px;
`;
type AboutProps = {
  handleClose: Function;
};

const OldConfiguratorWarning = ({ handleClose }: AboutProps) => {
  const accepted = async () => {
    window?.open("https://panel.aetherdigitalplatform.com", "_blank")?.focus();
  };

  const denied = () => {
    handleClose();
  };

  return (
    <Modal>
      <StyledModalBase handleClick={handleClose} header="Old software warning">
        <p style={{ fontSize: "1.8rem" }}>
          This is the old version of Zeus Configurator, it is not recommended to
          use it. Please go to the{" "}
          <a
            href="https://panel.aetherdigitalplatform.com"
            target="_blank"
            rel="noreferrer"
          >
            ADP platform
          </a>
          . If for some reason you need to use this version, close this popup,
          but remember that all new features are not supported with the old
          version.
        </p>
        <ButtonsWrapper>
          <Button secondary onClick={denied}>
            Close
          </Button>
          <Button onClick={accepted}>Go to ADP</Button>
        </ButtonsWrapper>
      </StyledModalBase>
    </Modal>
  );
};

export default OldConfiguratorWarning;
